import { useCallback, useState } from "react";
import ReportService from "../../../../../services/reportGeneration";
import { useSaveDownloaded } from "../../../../../lib/hooks/useSaveDownloaded";

export const useExport = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { save } = useSaveDownloaded(
    "contract-fees.xlsx",
    "application/octet-stream",
  );

  const onExport = useCallback(async () => {
    try {
      setIsLoading(true);

      const res = await ReportService.exportByName("ContractFees", {});

      save(res);

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [save]);

  return { isLoading, onExport };
};
